// SEO-friendly alt text for product images. Composes the product name with a
// short category descriptor and a Hamilton/Hillcrest qualifier — drives organic
// traffic from Google Images on queries like "cookie pies hamilton".
const CATEGORY_ALT_SUFFIX = {
  "cookie-pies":      "fresh-baked Cookie Pies Hamilton, made in Hillcrest by Just Dessert Me",
  "loaded-cookies":   "Loaded Cookies Hamilton, baked daily at Just Dessert Me Hillcrest",
  "other-treats":     "Hamilton dessert treats from Just Dessert Me, Hillcrest",
  "milkshakes":       "milkshakes at Just Dessert Me, Hamilton's home of rolled ice cream",
  "pancakes":         "pancakes Hamilton-made to order at Just Dessert Me Hillcrest",
  "waffles":          "waffles Hamilton-made to order at Just Dessert Me Hillcrest",
  "rolled-ice-cream": "rolled ice cream Hamilton, hand-rolled at Just Dessert Me Hillcrest",
  "desserts":         "Hamilton desserts at Just Dessert Me, Hillcrest dessert cafe",
};

const DEFAULT_SUFFIX = "Just Dessert Me — Hamilton's home of rolled ice cream, waffles & desserts";

export const getProductAlt = (product) => {
  if (!product?.name) return DEFAULT_SUFFIX;
  const suffix = CATEGORY_ALT_SUFFIX[product.category] || DEFAULT_SUFFIX;
  return `${product.name} — ${suffix}`;
};
